<template>
   <div>
    <CRow class="w-100 justify-content-center">
      <CCol md="4">
        <div class="w-100" >
        <div class="clearfix" >
          <CCardBody class="text-center">
            <CIcon width="60" height="60" name="cilMedicalCross"/>
          
          <h1 class="float-left display-3 mr-10">Coming Soon</h1>
          <div class="clearfix" />
          <h4 class="pt-2">The page you are looking for was under construction.</h4>
          <p class="text-muted"></p>
          </CCardBody>
        </div>
        
      </div>
      </CCol>
    </CRow>
 </div>
</template>

<script>
export default {
  name: 'BlankPage'
}
</script>
